import Logger from '@/lib/logger';

export var log = new Logger(true,true);
export default log;
